import { UpdateResult, useUpdateLibraryFetcher } from "./updateLibrary";
import { useCallback, useMemo } from "react";
import useToasts from "../../../root/core-ui/toast/useToasts";
import { UpdateSuccessToast, UpdateErrorToast } from "./updateLibraryToasts";
import { FetcherWithSubmitPromise } from "../../../../common/core-ui/usePromiseFetcher";

export interface UpdateLibrary {
  updateLibrary: () => void;
  fetcher: FetcherWithSubmitPromise<UpdateResult>;
}

export default function useUpdateLibrary(): [
  () => void,
  FetcherWithSubmitPromise<UpdateResult>,
] {
  const fetcher = useUpdateLibraryFetcher();
  const { showToast } = useToasts();

  const doUpdate = useCallback(() => {
    fetcher
      .submit(
        {},
        {
          action: `/actions/update-library`,
          method: "POST",
        }
      )
      .then((response) => {
        if (response.data?.ok) {
          showToast(<UpdateSuccessToast />);
        } else {
          showToast(<UpdateErrorToast />);
        }
      })
      .catch(() => showToast(<UpdateErrorToast />));
  }, [fetcher, showToast]);

  return useMemo(() => [doUpdate, fetcher], [doUpdate, fetcher]);
}
